<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<section id="wrapper" class="login-register login-sidebar" style="background-image:url(assets/images/background/login-register.jpg);">
    <div class="login-box card">
        <div class="card-body">

            <form ngNativeValidate [formGroup]="forma" (ngSubmit)="recuperarPassword()" class="form-horizontal form-material" id="loginform" action="index.html">
                <a href="javascript:void(0)" class="text-center db"><img src="assets/images/logo-icon.png" alt="Home" /><br/><img src="assets/images/logo-text.png" alt="Home" /></a>
                <h3 class="box-title m-t-40 m-b-0">¿Tienes problemas para iniciar sesión?</h3><br><small>Ingresa tu nombre de usuario o correo electrónico y te enviaremos un enlace para recuperar el acceso a tu cuenta.</small>
                <br>
                <div class="form-group ">
                    <div class="col-xs-12">
                        <input formControlName="correo" name="correo" class="form-control" type="email" required placeholder="Correo">
                    </div>
                </div>

                <div class="form-group text-center m-t-20">

                    <div class="col-xs-12">
                        <button class="btn btn-info btn-lg btn-block text-uppercase " [disabled]="!buttonDisabled" type="submit"><span [hidden]="buttonDisabled" ><i class="fa fa-spin fa-spinner"></i></span>Recuperar</button>
                    </div>




                </div>
                <br>
                <div class="form-group m-b-0">
                    <div class="col-sm-12 text-center">
                        <p class="text-center"><a routerLink="/login" class="text-info  "><b>Volver al inicio se sesión</b></a></p>
                    </div>
                </div>
            </form>
        </div>
    </div>
</section>
<!-- ============================================================== -->
<!-- End Wrapper -->
<!-- ============================================================== -->